import React from 'react';
import { Form, Input } from '@rocketseat/unform';
import * as Yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { FaCheckCircle } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { Container } from './styles';
import { updateProfileRequest } from '~/store/modules/user/actions';

export default function Profile() {
  const profile = useSelector(state => state.user.profile);
  const dispatch = useDispatch();
  const schema = Yup.object().shape({
    name: Yup.lazy(value =>
      value === '' ? Yup.string().strip(true) : Yup.string()
    ),
    email: Yup.lazy(value =>
      value === ''
        ? Yup.string().strip(true)
        : Yup.string().email('Should be a valid email')
    ),
    password: Yup.lazy(value =>
      value === ''
        ? Yup.string().strip(true)
        : Yup.string().min(
            6,
            'Your new password should contain at least 6 characters'
          )
    ),
    password_confirmation: Yup.lazy(value =>
      value === ''
        ? Yup.string().strip(true)
        : Yup.string().when('password', (value2, field) =>
            value2
              ? field
                  .required()
                  .oneOf([Yup.ref('password')], 'Password do not match')
              : field
          )
    ),
    oldPassword: Yup.lazy(value =>
      value === ''
        ? Yup.string().strip(true)
        : Yup.string().when('password', (value2, field) =>
            value2
              ? field
                  .required('You should provide your current password')
                  .min(
                    6,
                    'Your current password should contain at least 6 characters'
                  )
              : field.notRequired()
          )
    ),
  });
  function handleSubmit(data) {
    if (Object.keys(data).length <= 0) {
      toast.error('You should provide the information you want to update');
      return;
    }
    dispatch(updateProfileRequest(data));
  }
  return (
    <Container>
      <Form schema={schema} onSubmit={handleSubmit}>
        <Input name="name" placeholder={profile.name || 'Full name'} />
        <Input
          name="email"
          type="email"
          placeholder={profile.email || 'Email'}
        />
        <hr />
        <Input name="password" type="password" placeholder="New password" />
        <Input
          name="password_confirmation"
          type="password"
          placeholder="Confirm new password"
        />
        <Input
          name="oldPassword"
          type="password"
          placeholder="Current password"
        />
        <div>
          <button type="submit">
            <FaCheckCircle color="#FFF" size={22} />
            Salvar perfil
          </button>
        </div>
      </Form>
    </Container>
  );
}
